// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"167":"3f87973d","239":"75e06c3d","396":"cf37a21d","455":"a2c4e280","488":"be9540ab"}[chunkId] + ".chunk.js";
};